import type { AddressGroupDTO } from '@/api/base/DTOs';
import type { FieldsGroupAddressConfig } from '@/forms/typings';
import { encodeAddressLink } from '@/forms/utils/addressLink';

/** A group's address settings, with each option keyed by the Formik value that selects it. */
export const adaptAddressGroupResponse = (
  address?: AddressGroupDTO | null,
): FieldsGroupAddressConfig | undefined => {
  if (!address) return undefined;

  return {
    type: address.type,
    prompt: address.prompt ?? undefined,
    answerRequired: address.answerRequired,
    options: address.options.map(option => ({
      value: encodeAddressLink(option),
      target: option.target,
      label: option.label,
      targetFieldId: option.targetFieldID ?? undefined,
      enabled: option.enabled,
      preview: option.preview ?? undefined,
      disabledReason: option.disabledReason ?? undefined,
    })),
    linkValue: address.link ? encodeAddressLink(address.link) : undefined,
    hiddenFieldIds: address.hiddenFieldIDs,
    summaryFieldIds: address.summaryFieldIDs,
    nameFieldId: address.nameFieldID ?? undefined,
    effectiveAddress: address.effectiveAddress ?? undefined,
    linkedPoBoxMessage: address.linkedPoBoxMessage ?? undefined,
  };
};
